<nav
	class="navbar navbar-expand-lg fixed-top navbar-transparent animate__fadeInDown"
	color-on-scroll="10"
	id="navbar-top"
>
	<div class="container px-0">
		<div class="navbar-translate">
			<div>
				<a
					class="navbar-brand"
					placement="bottom"
					[routerLink]="['/']"
					target="_self"
					title="前往首頁"
				>
					<div class="logo d-flex justify-content-center">
						<img
							src="/bigaunt/assets/images/big-aunt-logo.png"
							alt="Big Aunt's"
							style="height: 10vh; width: 10vh"
						/>
						<h1 class="m-0">Big Aunt's | 大阿姨球員卡團拆</h1>
					</div>
				</a>
			</div>
			<button
				aria-controls="navigation-index"
				aria-label="Toggle navigation"
				class="navbar-toggler navbar-toggler"
				[attr.aria-expanded]="!isCollapsed"
				(click)="ToggleBGFilter()"
				id="navigation"
				type="button"
			>
				<ng-container *ngIf="isCollapsed">
					<span class="navbar-toggler">&equiv;</span>
				</ng-container>

				<ng-container *ngIf="!isCollapsed">
					<span class="navbar-toggler">&#x00d7;</span>
				</ng-container>
			</button>
		</div>
		<div
			class="navbar-collapse justify-content-start"
			[collapse]="isCollapsed"
			id="navigation"
		>
			<ul class="navbar-nav">
				<!-- ! web 2.0 的 navItem 寫在這邊 -->
				<li class="nav-item">
					<a
						class="nav-link"
						[routerLink]="['/']"
						placement="bottom"
						target="_self"
						title="前往首頁"
					>
						<p>首頁</p>
					</a>
				</li>
				<li class="nav-item">
					<a
						class="nav-link"
						[routerLink]="['/myAccount']"
						placement="bottom"
						target="_self"
						title="我的帳戶"
					>
						<p>我的帳戶</p>
					</a>
				</li>
				<li class="nav-item">
					<a
						class="nav-link"
						[routerLink]="['/products']"
						placement="bottom"
						target="_self"
						title="前往商品列表"
					>
						<p>商品列表</p>
					</a>
				</li>
				<!-- <li class="nav-item">
					<a
						class="nav-link"
						[routerLink]="['/teamsForm']"
						placement="bottom"
						target="_self"
						title="前往表單"
					>
						<p>BAS-048</p>
					</a>
				</li> -->
				<li class="nav-item d-none align-items-center">
					<p
						class="m-1"
						(click)="changeLanguage('zh-tw')"
					>
						中文
					</p>
					<p>|</p>
					<p
						class="m-1"
						(click)="changeLanguage('en')"
					>
						EN
					</p>
				</li>
			</ul>
		</div>
		<!-- <div *ngIf="getScreenWidth > 991">
			<button
				class="contact-us-btn"
				(click)="this.contactFormShow = true"
			>
				聯絡我們
			</button>
		</div> -->
	</div>
</nav>

<app-contact-dialog [(contactFormShow)]="contactFormShow"></app-contact-dialog>
<app-cookies-dialog></app-cookies-dialog>
